import styled from 'styled-components';

export const FloatButton = styled.div<{ $bottom?: number }>`
  position: fixed;
  bottom: ${(i) => i.$bottom ?? 76}px;
  z-index: 9;
  left: 50%;
  transform: translateX(calc(-100% - 12px));
  transition: all 0.3s ease-in-out;
`;
